












import Vue from "vue";

export default Vue.extend({
  methods: {
    scroll() {
      // 页面滚动到宝藏视频
      this.$emit("scroll");
    }
  }
});
